// extracted by mini-css-extract-plugin
export default {"name":"WorkUnitsInfos_name__HkL5N","icon":"WorkUnitsInfos_icon__dOLUq","wrapper":"WorkUnitsInfos_wrapper__7SXYZ"};